/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Api_Reference_DescriptionInputs */

const en_directory_api_reference_description = /** @type {(inputs: Directory_Api_Reference_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every endpoint of the agent channel — the authorization flow, the project API, the MCP server, and the stable error codes. This page stays in sync with the agent guide by construction.`)
};

const zh_directory_api_reference_description = /** @type {(inputs: Directory_Api_Reference_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent 通路的全部端点——授权流程、项目 API、MCP 服务器与稳定的错误码。本页与 Agent 指引同源生成，永不失同步。`)
};

/**
* | output |
* | --- |
* | "Every endpoint of the agent channel — the authorization flow, the project API, the MCP server, and the stable error codes. This page stays in sync with the a..." |
*
* @param {Directory_Api_Reference_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_api_reference_description = /** @type {((inputs?: Directory_Api_Reference_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Api_Reference_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_api_reference_description(inputs)
	return zh_directory_api_reference_description(inputs)
});
export { directory_api_reference_description as "directory.api_reference.description" }